// form
import { Controller, useFormContext } from 'react-hook-form';
// @mui
import CommonTextField, { CommonTextFieldProps } from './CommonTextField';

// ----------------------------------------------------------------------

type Props = CommonTextFieldProps & {
  name: string;
};

export default function RHFTextField({ name, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <CommonTextField
          {...field}
          value={typeof field.value === 'number' && field.value === 0 ? '' : field.value}
          error={error}
          {...other}
        />
      )}
    />
  );
}
